import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

export const useOptionalFormContext = () => {
  const formContext = useFormContext();

  const emptyContext = useMemo(() => ({
    formState: {
      errors: undefined,
    },
  }), []);

  return formContext ?? emptyContext;
};
